<!--
  SUP-580: Adding this permission to blanket notifications just for the offers and
  negotiations release. This will be changed ahead of the official notifications release.
-->
<p-toast
  *agHasPermission="PermissionEnum.PagesOffers"
  [key]="NOTIFICATION_TOAST_KEY"
  position="bottom-right"
  (onClose)="onClose($event)"
>
  <ng-template #headless let-message let-closeFn="closeFn">
    @if (message?.data?.severity === notificationRuleSeverityEnum.Alert) {
      <div
        class="grid max-h-58 max-w-120 grid-cols-[auto_1fr] gap-3.5 bg-interface-warning-muted-overlay p-3"
      >
        <div
          class="w-[6px] shrink-0 rounded-[4px] bg-interface-warning-default"
        ></div>
        <div
          class="grid grid-cols-1 gap-3.5"
          (click)="trackToastClicked(message.data)"
        >
          <div class="flex items-center">
            <ag1-badge-small
              variant="warning"
              label="Critical alert"
              leadingIcon="/assets/icons/general/warning.svg"
            />

            <p-button
              class="ml-auto"
              variant="text"
              severity="warn"
              size="small"
              (click)="
                closeFn($event);
                markNotificationAsRead(message.data.channelNotification);
                trackNotificationDismissed(message.data)
              "
            >
              <ng-template #icon>
                <svg-icon src="/assets/icons/general/close.svg" />
              </ng-template>
            </p-button>
          </div>

          <div class="grid grid-cols-1 gap-1.5">
            <span class="headings-small truncate text-text-common-contrast">
              {{ message.summary }}
            </span>

            <p class="line-clamp-3 text-text-common-contrast">
              {{ message.detail }}
            </p>
          </div>

          <div class="flex items-center gap-2">
            @if (message?.data?.actionLabel) {
              <p-button
                variant="outlined"
                size="small"
                severity="warn"
                [label]="message.data.actionLabel"
                (onClick)="
                  closeFn($event);
                  onAction(
                    message.data.metadata,
                    message.data.notificationRuleSlug
                  );
                  markNotificationAsRead(message.data.channelNotification);
                  trackNotificationCallToActionClick(message.data)
                "
              />
            } @else {
              <p-button
                variant="outlined"
                size="small"
                severity="warn"
                label="Got it"
                (click)="
                  closeFn($event);
                  markNotificationAsRead(message.data.channelNotification);
                  trackNotificationDismissed(message.data)
                "
              />
            }
            <p-button
              variant="text"
              size="small"
              severity="warn"
              label="Dismiss"
              (click)="
                closeFn($event);
                markNotificationAsRead(message.data.channelNotification);
                trackNotificationDismissed(message.data)
              "
            />
          </div>
        </div>
      </div>
    } @else if (message?.data?.severity === notificationRuleSeverityEnum.Info) {
      <div
        class="grid max-h-58 max-w-120 grid-cols-[auto_1fr] gap-3.5 bg-interface-informative-muted-overlay p-3"
      >
        <div
          class="w-[6px] shrink-0 rounded-[4px] bg-interface-informative-border-default"
        ></div>
        <div
          class="grid grid-cols-1 gap-3.5"
          (click)="trackToastClicked(message.data)"
        >
          <div class="flex items-center">
            <ag1-badge-small variant="informative" label="Update" />

            <p-button
              class="ml-auto"
              variant="text"
              size="small"
              (click)="
                closeFn($event);
                markNotificationAsRead(message.data.channelNotification);
                trackNotificationDismissed(message.data)
              "
            >
              <ng-template #icon>
                <svg-icon src="/assets/icons/general/close.svg" />
              </ng-template>
            </p-button>
          </div>

          <div class="grid grid-cols-1 gap-1.5">
            <span class="headings-small truncate text-text-common-contrast">{{
              message.summary
            }}</span>
            <p class="line-clamp-3 text-text-common-contrast">
              {{ message.detail }}
            </p>
          </div>

          <div class="flex items-center gap-2">
            @if (message.data.actionLabel) {
              <p-button
                variant="outlined"
                size="small"
                [label]="$safeNavigationMigration(message?.data?.actionLabel)"
                (onClick)="
                  closeFn($event);
                  onAction(
                    message.data.metadata,
                    message.data.notificationRuleSlug
                  );
                  markNotificationAsRead(message.data.channelNotification);
                  trackNotificationCallToActionClick(message.data)
                "
              />
            } @else {
              <p-button
                variant="outlined"
                size="small"
                label="Got it"
                (click)="
                  closeFn($event);
                  markNotificationAsRead(message.data.channelNotification);
                  trackNotificationDismissed(message.data)
                "
              />
            }
            <p-button
              variant="text"
              size="small"
              label="Dismiss"
              (click)="
                closeFn($event);
                markNotificationAsRead(message.data.channelNotification);
                trackNotificationDismissed(message.data)
              "
            />
          </div>
        </div>
      </div>
    }
  </ng-template>
</p-toast>
